let dropdownButtons = document.querySelectorAll('.dropdown__btn');
let dropdownBlocks = document.querySelectorAll('.dropdown__block');


  for (let i = 0; i < dropdownButtons.length; i++) {
    const dropdownButton = dropdownButtons[i];
    const dropdownBlock = dropdownBlocks[i];
    const targetId = `dropdown-${i +1}`;

    dropdownButton.setAttribute('data-target', targetId);
    dropdownBlock.setAttribute('data-id', targetId);
  
    dropdownButton.addEventListener('click', () => {
      dropdownBlock.classList.toggle('hidden');
      dropdownButton.classList.toggle('active');
    });  
  }
 
